import React from "react";
import { withRouter } from "react-router-dom";

import { HIPAA } from "@/core/constants";

import { getQueryParams } from "../../utils/filters";
import { Policy } from "../../components/Policy/Policy";

const HipaaPolicyPage = (props) => {
  const version = getQueryParams("version", props.location.search);

  return <Policy policyType={HIPAA} version={version} />;
};

export default withRouter(HipaaPolicyPage);
